import UserViewPage from './userViewPage';

export default UserViewPage;
